import React from 'react'
import {  Row, Col } from 'react-bootstrap'
import {Nav  } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { Container, ListGroup, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (

        <>
        
        <footer className="footer">
        

        <Container>

        <hr/>

        <Row>
          <Col>
          <Link to='/terms-and-conditions'>
                    
                    <span style={{fontWeight:'bold'}}>Terms and Conditions</span>
                  
            </Link>
          
          </Col>
          <Col>
          <LinkContainer to='/privacy-policy'>
                <Nav.Link> 
                <span style={{fontWeight:'bold'}}>Privacy Policy</span>
                </Nav.Link>
            </LinkContainer>
          
          </Col>
          <Col>
          
             
              <span style={{fontWeight:'bold'}}>pixagan@gmail.com</span>
             
            
         
          </Col>
        </Row>

        <hr/>

        <Row>
          <Col className='text-center py-3 mt-0'>
          <span style={{fontWeight:'bold'}}> &copy; 2025-, Pixagan Technologies Private Limited. All rights reserved. | </span>
          </Col>
        </Row>

        <hr />

        </Container>





        </footer>
        
        </>


        )
    }
    
    export default Footer